import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { NotificationFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { NetworkService, PullToRefreshService, TicketsService } from '@ridango/core/lib/services';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';
import { Ticket } from '@ridango/core/lib/services/tickets.service';
import { TicketModalStateService } from '../../services/ticket-modal-state.service';
import { interval, Observable } from 'rxjs';
import { debounceTime, filter, map, skip, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-ticket-card-container',
    templateUrl: './ticket-card-container.component.html',
    styleUrls: ['./ticket-card-container.component.scss']
})
export class TicketCardContainerComponent extends BaseComponent implements OnInit, AfterViewInit {
    public ticketsLoaded$ = this.ticketsService.loaded$;
    public tickets$ = this.ticketsService.tickets$;
    public activeTickets$ = this.ticketsService.activeTickets$;
    public inactiveTickets$ = this.ticketsService.inactiveTickets$;
    isMobileSize$: Observable<boolean>;
    public recentlyUsedTickets$ = this.ticketsService.recentlyUsedTickets$;
    public isInLandscapeMode = this.screenOrientationService.isInLandscapeMode;
    public pageSize = this.ticketsService.PAGE_SIZE;

    @ViewChild(CdkScrollable) viewport: CdkScrollable;

    constructor(
        @Inject('ENV') public env: Env,
        private ticketsService: TicketsService,
        private pullToRefresh: PullToRefreshService,
        private breakpointObserver: BreakpointObserver,
        private screenOrientationService: ScreenOrientationService,
        private notification: NotificationFacade,
        private network: NetworkService,
        private ticketModalStateService: TicketModalStateService
    ) {
        super();
    }
    ngAfterViewInit(): void {
        this.viewport
            .elementScrolled()
            .pipe(
                skip(1),
                debounceTime(100),
                map(() => this.viewport.measureScrollOffset('bottom')),
                filter(() => Boolean(this.network.getCurrentStatus())),
                filter((offset) => Math.floor(offset) < 1),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe(() => {
                this.ticketsService.loadNextPageTickets();
            });
    }

    ngOnInit() {
        this.ticketsService.registerReload().pipe(takeUntil(this.componentDestroyed$)).subscribe();
        this.ticketsService.registerNextPage().pipe(takeUntil(this.componentDestroyed$)).subscribe();
        this.isMobileSize$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((v) => v.matches));
        if (this.network.getCurrentStatus()) {
            this.ticketsService.reloadTickets();
        }
        interval(60_000)
            .pipe(
                filter(() => Boolean(this.network.getCurrentStatus())),
                filter(() => !this.ticketModalStateService.isModalOpen()),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe(() => this.ticketsService.reloadTickets());
        this.pullToRefresh.methodCalled$.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            this.handleRefreshTickets();
        });
    }

    handleRefreshTickets() {
        if (!this.network.getCurrentStatus()) {
            return;
        }
        this.notification.removeAll();
        this.ticketsService.reloadTickets();
    }

    getTicketId(_: number, ticket: Ticket): string {
        return ticket.id ?? ticket.docNum?.toString();
    }
}
